import http from '@/services/http';
import { locationsManagementFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const locationsManagement = {
  autocompleteFetch(key, value, exact = false, searchById = false) {
    const filter = {
      where: {
        or: [{ [key]: exact ? value : { regexp: `/${value}/i` } }],
      },
    };
    if (searchById && Number.isInteger(Number(value))) {
      filter.where.or.push({
        id: value,
      });
    }
    return http.request({
      method: 'get',
      url: '/locations',
      params: { filter },
    });
  },
  index(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(
      filterStatus,
      locationsManagementFilters
    );
    return http.request({
      method: 'get',
      url: '/locations',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(
      filterStatus,
      locationsManagementFilters
    );
    return http.request({
      method: 'get',
      url: '/locations/count',
      params: { where },
      ...config,
    });
  },
  create(data) {
    return http.request({
      method: 'post',
      url: '/locations',
      data,
    });
  },
  patch(id, data) {
    return http.request({
      method: 'patch',
      url: `/locations/${id}`,
      data,
    });
  },
  getLocation(id) {
    return http.request({
      method: 'get',
      url: `/locations/${id}`,
    });
  },
  getCustomerLocations(tableFilters, customerId) {
    return http.request({
      method: 'get',
      url: '/location-customer-departments',
      params: {
        filter: { ...tableFilters, include: ['location'] },
        customerId,
      },
    });
  },
  customerLocationsCount(customerId) {
    return http.request({
      method: 'get',
      url: '/location-customer-departments/count',
      params: {
        customerId,
      },
    });
  },
  customerLocationsCreate(data) {
    return http.request({
      method: 'post',
      url: '/location-customer-departments',
      data,
    });
  },
  customerLocationsDelete(id) {
    return http.request({
      method: 'delete',
      url: `/location-customer-departments/${id}`,
    });
  },
  customerLocationsPatch(id, data) {
    return http.request({
      method: 'patch',
      url: `/location-customer-departments/${id}`,
      data,
    });
  },
  fetchPrinters() {
    return http.request({
      method: 'get',
      url: '/cup-printers',
    });
  },
};

export default locationsManagement;
